import React from "react";
import { ProductCardLabelWeightType } from "types/AssistantTypes";
import styles from "./anagrafica.module.scss";
import { useTranslation } from "react-i18next";

type AnagraficaProps = {
  data: ProductCardLabelWeightType[];
};

export const Anagrafica: React.FC<AnagraficaProps> = ({ data }) => {
  const { t } = useTranslation();

  const infoMap = React.useMemo(() => {
    return Object.fromEntries(
      data.map((item) => [
        item.label,
        { label: item.label, weight: item.weight },
      ]),
    );
  }, [data]);

  return (
    <div className={styles.anagraficaContainer}>
      <h2 className={styles.sectionTitle}>{t("productCard.anagrafica")}</h2>
      <div className={styles.infoGrid}>
        <div className={styles.column}>
          {infoMap["ISIN"] && (
            <p>
              {infoMap["ISIN"].label + ":"}
              <span>{infoMap["ISIN"].weight}</span>
            </p>
          )}
          {infoMap["Categoria"] && (
            <p>
              {infoMap["Categoria"].label + ":"}
              <span>{infoMap["Categoria"].weight}</span>
            </p>
          )}
          {infoMap["Valuta"] && (
            <p>
              {infoMap["Valuta"].label + ":"}
              <span>{infoMap["Valuta"].weight}</span>
            </p>
          )}
          {infoMap["Tipo emittente"] && (
            <p>
              {infoMap["Tipo emittente"].label + ":"}
              <span>{infoMap["Tipo emittente"].weight}</span>
            </p>
          )}
          {infoMap["Emittente"] && (
            <p>
              {infoMap["Emittente"].label + ":"}
              <span>{infoMap["Emittente"].weight}</span>
            </p>
          )}
        </div>
        <div className={styles.column}>
          {infoMap["Tipo bond"] && (
            <p>
              {infoMap["Tipo bond"].label + ":"}
              <span>{infoMap["Tipo bond"].weight}</span>
            </p>
          )}
          {infoMap["Data emissione"] && (
            <p>
              {infoMap["Data emissione"].label + ":"}
              <span>{infoMap["Data emissione"].weight}</span>
            </p>
          )}
          {infoMap["Data scadenza"] && (
            <p>
              {infoMap["Data scadenza"].label + ":"}
              <span>{infoMap["Data scadenza"].weight}</span>
            </p>
          )}
          {infoMap["Tasso cedolare"] && (
            <p>
              {infoMap["Tasso cedolare"].label + ":"}
              <span>{infoMap["Tasso cedolare"].weight}</span>
            </p>
          )}
          {infoMap["Settore"] && (
            <p>
              {infoMap["Settore"].label + ":"}
              <span>{infoMap["Settore"].weight}</span>
            </p>
          )}
        </div>
        <div className={styles.column}>
          {infoMap["Mercato di quotazione"] && (
            <p>
              {infoMap["Mercato di quotazione"].label + ":"}
              <span>{infoMap["Mercato di quotazione"].weight}</span>
            </p>
          )}
          {infoMap["Prezzo di rimborso"] && (
            <p>
              {infoMap["Prezzo di rimborso"].label + ":"}
              <span>{infoMap["Prezzo di rimborso"].weight}</span>
            </p>
          )}
          {infoMap["Taglio minimo"] && (
            <p>
              {infoMap["Taglio minimo"].label + ":"}
              <span>{infoMap["Taglio minimo"].weight}</span>
            </p>
          )}
          {infoMap["Call"] && (
            <p>
              {infoMap["Call"].label + ":"}
              <span>{infoMap["Call"].weight}</span>
            </p>
          )}
          {infoMap["Put"] && (
            <p>
              {infoMap["Put"].label + ":"}
              <span>{infoMap["Put"].weight}</span>
            </p>
          )}
        </div>
        <div className={styles.column}>
          {infoMap["Amortizing"] && (
            <p>
              {infoMap["Amortizing"].label + ":"}
              <span>{infoMap["Amortizing"].weight}</span>
            </p>
          )}
          {infoMap["Bail-in"] && (
            <p>
              {infoMap["Bail-in"].label + ":"}
              <span>{infoMap["Bail-in"].weight}</span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Anagrafica;
